import axios from './../constants/axios';
import * as types from './../constants/actionTypes';

export function loadAllContactSuccess(payload) {
   return { type: types.LOAD_ALL_CONTACTS_SUCCESS, payload: payload };
}


export function loadAllContact() {
   return function (dispatch) {
      return axios
         .get('contacts')
         .then(function (res) {
            dispatch(loadAllContactSuccess({
               contacts: res.data
            }));
         });
   };
}



/** WEBPACK FOOTER **
 ** ./src/actions/contactActions.js
 **/